/* eslint-disable @typescript-eslint/no-explicit-any */
import { getIn } from 'final-form';

import { knmErknmFieldsDataByFlatNameMap } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsDataByFlatNameMap';
import { knmErpFieldsDataByFlatNameMap } from 'KnmErpPackage/MainModule/constants/knmErpFieldsDataByFlatNameMap';
import { knmPmFieldsDataByFlatNameMap } from 'KnmPmPackage/MainModule/constants/knmPmFieldsDataByFlatNameMap';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';

import { KnmSystemTypesEnum } from '../enums/KnmSystemTypesEnum';
import { KnmFormFieldsNamesTemplatesTypeMap } from '../types/knmFormFieldsNamesTemplatesTypeMap';

const fieldsDataByFlatNameMapBySystemType = {
  [KnmSystemTypesEnum.ERKNM]: knmErknmFieldsDataByFlatNameMap,
  [KnmSystemTypesEnum.ERP]: knmErpFieldsDataByFlatNameMap,
  [KnmSystemTypesEnum.PM]: knmPmFieldsDataByFlatNameMap,
};

export const getErrorFieldDataByFlatName = (
  flatName: string,
  formRef: IKnmFormRef,
  knmSystemType: KnmSystemTypesEnum,
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
) => {
  const nameTemplate: KnmFormFieldsNamesTemplatesTypeMap<typeof knmSystemType> = flatName.replace(
    /\[(.+?)\]/g,
    '[i]',
  ) as any;
  const fieldsDataByFlatNameMap = fieldsDataByFlatNameMapBySystemType[knmSystemType](created, settings);
  const flatNameSplit = flatName.split('.');
  const nameTemplateSplit = nameTemplate.split('.');
  const splitNameTemplateByArray = nameTemplate.split('[i].');
  const isFirstNotArrayField =
    nameTemplateSplit.length > 1 &&
    nameTemplateSplit[0].indexOf('[i]') === -1 &&
    nameTemplateSplit[1].indexOf('[i]') > -1;

  // для полей большой вложенности в несколько массивов
  if (splitNameTemplateByArray.length > 2 || isFirstNotArrayField) {
    let complexScrollElementId: string = '';
    let previousParentFieldName: string = '';

    flatNameSplit.forEach(name => {
      if (name.includes('[')) {
        const parentFieldName = name;
        const parentFieldArrayIndex = parentFieldName?.substring(
          parentFieldName.lastIndexOf('[') + 1,
          parentFieldName.lastIndexOf(']'),
        );

        if (parentFieldName && parentFieldArrayIndex) {
          const parentFieldArrayName = parentFieldName.replace(/\[(.+?)\]/g, '');

          previousParentFieldName =
            previousParentFieldName?.length > 0
              ? `${previousParentFieldName}.${parentFieldArrayName}`
              : parentFieldArrayName;

          // Значение берём из values, а не из getFieldState: поле внутри свёрнутого
          // аккордеона во final-form не зарегистрировано, и getFieldState вернёт undefined
          const parentFieldValue = getIn(formRef.current.getState().values, previousParentFieldName)?.[
            parentFieldArrayIndex
          ];

          const parentFieldId = parentFieldValue?.listId || parentFieldValue?.guid || parentFieldArrayIndex;

          complexScrollElementId += `${parentFieldName.replace(`[${parentFieldArrayIndex}]`, `[${parentFieldId}]`)}.`;
          previousParentFieldName += `[${parentFieldArrayIndex}]`;
        }
      } else {
        complexScrollElementId += `${name}.`;

        if (isFirstNotArrayField) {
          previousParentFieldName = `${previousParentFieldName ? `${previousParentFieldName}.` : ''}${name}`;
        }
      }
    });

    const scrollElementId = fieldsDataByFlatNameMap[nameTemplate]
      ?.getScrollElementId(complexScrollElementId.substring(0, complexScrollElementId.length - 1))
      .replace('undefined', '0');

    return {
      nameTemplate,
      title: fieldsDataByFlatNameMap[nameTemplate]?.title,
      scrollElementId,
      parentElementId: undefined,
    };
  }

  const parentFieldName: KnmFormFieldsNamesTemplatesTypeMap<typeof knmSystemType> | undefined =
    flatNameSplit.length > 1 ? (flatNameSplit[0] as any) : undefined;
  const parentFieldArrayIndex = parentFieldName?.substring(
    parentFieldName.lastIndexOf('[') + 1,
    parentFieldName.lastIndexOf(']'),
  );
  let parentFieldId: string | undefined;

  if (parentFieldName && parentFieldArrayIndex) {
    const parentFieldArrayName = parentFieldName.replace(/\[(.+?)\]/g, '');

    // Блоки, у которых в id элемента лежит не listId, а индекс в массиве
    // (например, `requirements[0]`), иначе ссылка вела бы на первый элемент списка
    parentFieldId =
      getIn(formRef.current.getState().values, parentFieldArrayName)?.[parentFieldArrayIndex]?.listId ||
      parentFieldArrayIndex;
  }

  const scrollElementId = fieldsDataByFlatNameMap[nameTemplate]
    ?.getScrollElementId(parentFieldId)
    .replace('undefined', '0');

  return {
    nameTemplate,
    title: fieldsDataByFlatNameMap[nameTemplate]?.title,
    scrollElementId,
    parentElementId: undefined,
  };
};
